import React from 'react';
import { motion } from 'framer-motion'; // Importiere framer-motion
import PayButton from "../BlockPayment/components/PayButton";
import BlockSummary from "../BlockElements/BlockSummary";
import BlockComment from "../BlockElements/BlockComment";
import BlockReview from "./components/BlockReview";
import BlockTerms from "../BlockElements/BlockTerms";

import { useReduxStore } from '../../../../redux/checkoutredux/ReduxCheckoutContext.tsx';

const PageReview = () => {
  const store = useReduxStore(); 

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={{
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 }
      }}
      transition={{ duration: 0.7 }} // Hier wird die Dauer des Fade-Effekts auf 0,5 Sekunden eingestellt
    >
      <div className="ips-pagereview" id="order_review">
        <div className="my-4"><BlockSummary pagetype="review" store={store}/></div>
        <div className="my-4"><BlockReview store={store}/></div>
        <div className="my-4"><BlockComment store={store}/></div>
        {/* <div className="my-4"><BlockTerms store={store}/></div> */}
        <div className="my-4"><PayButton pagetype="review" store={store}/></div>
        <div className="row my-4"></div>
        <div className="row my-4"></div>
      </div>
    </motion.div>
  );
};

export default PageReview;